import config from '@config';
import { AuthContext } from '../context';
import { useAuthEffect, useTrackAccessTokens } from './hooks';
import { DurationLike } from 'luxon';

const INTERVAL_TIME = 60 * 1000;

const durationOffset: DurationLike = { minutes: 2 };

export function Auth({ children }: AuthProps): JSX.Element {
	const isSupported =
		config?.app?.auth?.type === 'cognito' &&
		config?.app?.auth?.enabled === true;
	const authEffectResponse = useAuthEffect({
		isSupported,
	});

	useTrackAccessTokens({
		...authEffectResponse,
		interval: INTERVAL_TIME,
		durationOffset,
		isSupported,
	});

	const { isAuthenticated, accessToken, refreshToken } = authEffectResponse;

	return (
		<AuthContext.Provider
			value={{
				isSupported,
				isAuthenticated,
				accessToken,
				refreshToken,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
}

interface AuthProps {
	children: string | JSX.Element | JSX.Element[];
}
